import React from 'react'
import UISelect from 'components/shared/UISelect'

const UserSelect = ({ selectedValue, onUserIdChange, options, filter, renderSelectedValue = undefined, className, clearable }) => (
  <UISelect
    value={selectedValue}
    options={options}
    filterOption={filter}
    valueComponent={renderSelectedValue}
    onChange={onUserIdChange}
    className={className}
    clearable={clearable}
  />
)

export default UserSelect



// WEBPACK FOOTER //
// ./src/scripts/components/UserSelect/component.js